export const Notices = {
  SingleFileMode: 'single_file_mode',
  CompactDiffLines: 'compact_diff_lines',
  FilesChangedOptOut: 'files_changed_opt_out',
  PullRequestModernHeader: 'pull_request_modern_header',
} as const

export type PullRequestNotices = (typeof Notices)[keyof typeof Notices]

export type UserNotice<T> = {
  name: T
  dismissed: boolean
}
